import React from 'react';
import AppFormSelect from '../AppFormSelect';
import { HOTEL_SEARCHBOX_CONFIG } from '@/config';
import { PrebookHotelSummaryModel, PreBookPassengerGenderModel, RoomSearchInfo } from '@/__generated';
import { cloneDeep, range } from 'lodash';

type Props = {
  bookingSummary: PrebookHotelSummaryModel;
  passengerGenders: PreBookPassengerGenderModel[];
  onPassengerGendersChange: (v: PreBookPassengerGenderModel[]) => void;
};
const createOptions = (noAdults: number) => {
  return range(0, noAdults + 1).map(i => ({ value: i, label: `${i} person` }));
};

export default function GuestNumber({ bookingSummary, passengerGenders, onPassengerGendersChange }: Props) {
  const onMaleChange = (roomIndex: number, male: number) => {
    console.log(roomIndex, male);
    let genders = cloneDeep(passengerGenders);
    genders.forEach(x => {
      if (x.roomIndex === roomIndex) {
        x.maleCount = male;
      }
    });
    onPassengerGendersChange(genders);
  };
  return (
    <div className="row x-gap-10 y-gap-20  mt-20">
      <div className="col-12  ">
        <div className="d-flex align-items-center">
          <div className="fw-bold text-18 text-blue-1  rounded-2 pr-10 text-uppercase">NUMBER OF GUESTS</div>
          <div style={{ flex: 1, border: '1px dashed #cccccc' }} />
        </div>
      </div>
      <div className="mt-20 ">
        <div className="row x-gap-10 y-gap-20 fw-500 mb-10 bg-blue-2 rounded">
          <div className="col-md-3 col-2 sm-col-2 fw-500 text-14 text-center">Room</div>
          <div className="col-md-3 col-5 sm-col-5 fw-500 text-14  text-center">Adults(Male)</div>
          <div className="col-md-3 col-5 sm-col-5 fw-500 text-14  text-center">Adults(Female)</div>
          <div className="col-md-3 sm:d-none fw-500 text-14 text-center">{`Children(${HOTEL_SEARCHBOX_CONFIG.childrenMinAge}-${HOTEL_SEARCHBOX_CONFIG.childrenMaxAge})`}</div>
        </div>
        {passengerGenders?.map(room => {
          const roomInfo = bookingSummary.rooms?.find(x => x.roomIndex === room.roomIndex) || { noOfAdult: 0, noOfChild: 0 };
          const noOfAdult = roomInfo.noOfAdult || 0;
          const options = createOptions(noOfAdult);
          var maleCount = passengerGenders.find(x => x.roomIndex === room.roomIndex)?.maleCount || 0;

          return (
            <div className="row x-gap-10 y-gap-10 text-14 " key={room.roomIndex}>
              <div className="col-md-3 col-2 sm-col-2 text-center fw-500" style={{ lineHeight: '42px' }}>
                {`Room #${(room.roomIndex || 0) + 1}`}
              </div>
              <div className="col-md-3 col-5 sm-col-5 text-center px-20">
                <AppFormSelect value={maleCount} options={options} onChange={v => onMaleChange(room.roomIndex || 0, (v as any).value)} />
              </div>
              <div className="col-md-3 col-5 sm-col-5 text-center px-20">
                <AppFormSelect
                  value={noOfAdult - maleCount}
                  options={options}
                  onChange={v => onMaleChange(room.roomIndex || 0, noOfAdult - (v as any).value)}
                />
              </div>
              <div className="col-md-3 sm:d-none text-center fw-500" style={{ lineHeight: '42px' }}>
                {`${roomInfo.noOfChild} children`}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
